export const navigateToManualDeployment = (
  navigate,
  selectedCVES,
  selectedDevices,
) => {
  const patchIds = selectedCVES
    ?.map((selectedCVE) => selectedCVE.orgPatchId)
    .filter(Boolean);

  const deviceIds = selectedDevices?.map((device) => ({
    deviceId: device.id || device.deviceId,
    deviceName: device.deviceName,
  }));

  navigate("/app/secure/deployment/manual/add-profile", {
    state: {
      patchIds,
      deviceIds,
      operationType: "install",
    },
  });
};
